import React, { useState } from 'react'
import { TagIcon, XMarkIcon } from '@heroicons/react/24/solid'
import InputField from '../common/InputField'

// eslint-disable-next-line no-unused-vars
export const RequestBidModal = ({ isOpen, onClose, onSubmit, productName, productId }) => {
  const [quantity, setQuantity] = useState(1)

  const handleQuantityChange = (event) => {
    const value = event.target.value
    if (/^\d*$/.test(value)) {
      setQuantity(value === '' ? '' : parseInt(value, 10))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (quantity > 0) {
      onSubmit(productId, quantity)
      onClose()
    } else {
      alert('Please enter a valid quantity greater than 0.')
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative bg-background rounded-lg shadow-xl p-6 w-full max-w-sm mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          onClick={onClose}
          aria-label="Close modal"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 mb-4">
          <TagIcon className="h-10 w-10 text-green-600" aria-hidden="true" />
        </div>

        <div className="text-center">
          <h3
            className="text-lg font-bold leading-6 text-gray-900 capitalize mb-2"
            id="modal-title"
          >
            Submit Product Bidding
          </h3>
          <p className="text-sm font-normal text-gray-700 text-center mb-6">
            Customers can submit Product Bidding to notify all retailers offering that product that
            they are interested in receiving bids.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <InputField
            label="Request Quantity"
            id="quantity"
            type="number"
            value={quantity}
            onChange={handleQuantityChange}
            required={true}
            min="1"
            placeholder="Enter quantity"
          />
          <button
            type="submit"
            className="w-full px-6 py-3 text-lg font-medium text-white capitalize bg-gradient-to-r from-secondary-700 to-secondary-500 rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-600 transition-opacity shadow disabled:opacity-50"
            disabled={!quantity || quantity <= 0}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  )
}
